
const releaseNotes = {
  getNotesByVersion(version) {

    return releaseNotesByVersion[version]

  }
  
}

const releaseNotesByVersion = {
  "2.14": `
  <p><b>Release Summary: UI/UX improvements, misc user experience improvements, reporting improvements.</b></p>
  `,
  "2.13": `
  <p><b>Release Summary: UI/UX improvements, misc user experience improvements, video player improvements.</b></p>
  `,
  "2.12": `
  <p><b>Release Summary: UI/UX improvements, misc user experience improvements, new logo and assets.</b></p>
  `,
  "2.11": `
  <p><b>Release Summary: UI/UX improvements, misc user experience improvements, admin and role improvements.</b></p>
  `,
  "2.10": `
  <p><b>Release Summary: UI/UX improvements, misc user experience improvements, new ordering options for courses.</b></p>
  `,
  "2.9": `
  <p><b>Release Summary: UI/UX improvements, misc user experience improvements, new access options for groups.</b></p>
  `,
  "2.8": `
  <p><b>Release Summary: UI/UX improvements, misc user experience improvements, updates to simulation front end.</b></p>
  `,
  "2.7": `
  <p><b>Release Summary: UI/UX improvements, misc user experience improvements, additional content type options.</b></p>
  `,
  "2.6": `
  <p><b>Release Summary: UI/UX improvements, misc user experience improvements, admin user stats improvements, admin build tool improvements.</b></p>
  `,
  "2.5": `
  <p><b>Release Summary: UI/UX and email improvements, misc user experience improvements, email updates.</b></p>
  `,
  "2.4": `
  <p><b>Release Summary: UI/UX improvements, navbar and navigations improvements, migrations, stability fixes.</b></p>
  `,
  "2.3": `
  <p><b>Release Summary: UI/UX improvements, navbar and navigations improvements, library navigation.</b></p>
  `,
  "2.2": `
  <p><b>Release Summary: UI/UX improvements, misc user experience improvements, new sso integrations.</b></p>
  `,
  "2.1": `
  <p><b>Release Summary: UI/UX improvements, misc user experience improvements, admin dashboard access controls.</b></p>
  `,
  "2.0": `
  <p><b>Release Summary: UI/UX improvements, misc user experience improvements, Hub launch.</b></p>
  `,
  "1.35": `
  <p><b>Release Summary: UI/UX improvements, misc user experience improvements, resource links.</b></p>
  `,
  "1.34": `
  <p><b>Release Summary: UI/UX improvements, misc user experience improvements, analytics reports improvements.</b></p>
  `,
  "1.33": `
  <p><b>Release Summary: UI/UX improvements, misc user experience improvements, scripting utils.</b></p>
  `,
  "1.32": `
  <p><b>Release Summary: UI/UX improvements, misc user experience improvements.</b></p>
  `,
  "1.31": `
  <p><b>Release Summary: UI/UX improvements, misc user experience improvements.</b></p>
  `,
  "1.30": `
  <p><b>Release Summary: UI/UX improvements, misc user experience improvements.</b></p>
  `,
  "1.29": `
  <p><b>Release Summary: UI/UX improvements, misc user experience improvements.</b></p>
  `,
  "1.28": `
  <p><b>Release Summary: UI/UX improvements, misc user experience improvements.</b></p>
  `,
  "1.27": `
  <p><b>Release Summary: UI/UX improvements, misc user experience improvements.</b></p>
  `,
  "1.26": `
  <p><b>Release Summary: UI/UX improvements, misc user experience improvements.</b></p>
  `
  ,"1.25": `
  <p><b>Release Summary: UI/UX improvements, misc user experience improvements.</b></p>
  `
  ,"1.24": `
  <p><b>Release Summary: UI/UX improvements, misc user experience improvements.</b></p>
  `
  ,"1.23": `
  <p><b>Release Summary: General stability improvements, misc user experience improvements.</b></p>
  `
  , "1.22": `
  <p><b>Release Summary: General stability improvements, API integrations</b></p>
  `
  , "1.21": `
  <p><b>Release Summary: Release is a continued focus on enhancing how Pro-ficiency Administrators and 'Analytics users' evaluate data within our training modules. Specifically, we improved the experience of navigating completion reports and user metric reports. Our goal is to create more opportunities to better analyze, view, and extract data of our training modules through filtering</b></p>
  <hr/>
  <p><b>Feature #1: New Analytic Filters</b></p>
  <ul>
    <li><b>What is the feature:</b> Course analytic reports (user metrics and heat map reports) can now be filtered by the LDO score, the INC score, and metric category</li>
    <li><b>Who is this feature for?:</b> Study Analytic users and Advanced Analytics users</li>
    <li><b>Where to find it:</b> Programs dashboard > Program details > Select the course or individual training module >  User Analytics > Click ‘Show Analytics Options’   </li>
  </ul>
  <p><b>Quick Summary</b></p>
  <ul>
    <li>Users can now filter analytic reports by Likelihood of Deviation (LDO), Impact of Noncompliance (INC), and by the topic of the metric.
    <ul>
    <li>The Likelihood of a Protocol Deviation Occurring (LDO) indicates how likely it is that the sites will make a mistake, or deviate from the protocol, during the study for a given scenario.  The Impact of Noncompliance (INC) on the other hand, indicates the impact it will have if the site does make that mistake during the trial</li>
    <li>1 = Low</li>
    <li>2 = Medium</li>
    <li>3 = High</li>
    </ul></li>
  </ul>
  <hr/>
  <p><b>Feature #2: Single Metric Report</b></p>
  <ul>
    <li><b>What is the feature:</b> A new detailed report of individual metrics</li>
    <li><b>Who is this feature for?:</b> Advanced Analytics users</li>
    <li><b>Where to find it:</b> Programs dashboard > Select program > Program details >  Select a metric to analyze
    <ul>
      <li>Show User Filter Options now include:
        <ul>
          <li>Site number or Team name</li>
          <li>Status (All, Active users, Expired, Deactivated)</li>
        </ul>
        </li>
      <li>Title of Metric</li>
      <li>Video and question associated with the metric</li>
      <li>Percentage breakdown of correct versus incorrect options</li>
    </ul>
    </li>
  </ul>
  <p><b>Quick Summary</b></p>
  <ul>
    <li>Each metric within a training module is hyperlinked to a report that displays the percentage of what users answered on their first try. Single metric reports apply to scenes where a metric is being tracked such as user responses or decision trees. <For example: Single Metric Reports now showcase how confident users feel using a specific device or protocol after taking the training module.></li>
  </ul>
  <hr/>
  <p><b>Feature #3: New columns on completion report</b></p>
  <ul>
    <li><b>What is the feature: </b>2 new columns have been added to exported completion reports: Onboarded and Single sign-on (SSO)
    <ul>
      <li>Note: Users and subportals that use SSO will not show as onboarded on the completion report since their sign-on process is separate from the Pro-ficiency log-in page</li>
    </ul>
    </li>
    <li><b>Who is this feature for?:</b> All Analytics users</li>
    <li><b>Where to find it:</b> Programs dashboard > Select desired program > Program details > Click ‘View Completion Report’ > Click ‘Export’ > Download </li>
  </ul>
  <p><b>Quick Summary</b></p>
  <ul>
    <li>Admins can now see which users have onboarded and if they have access to the SSO. </li>
    <li><b>Tip:</b> When viewing completion report on GoogleSheets or Excel, you can easily narrow down large amounts of data by adding a filter to the header of the report:
      <ul>
        <li>Select the ‘Data’ Tab and select ‘Create a filter'</li>
      </ul>
    </li>
  </ul>
  `
,  "1.20": `
  <p><b>New Feature 1: Add users/sites/roles filters to aggregate (combine) reports</b></p>
  <ul>
    <li><b>What is the feature:</b> New filters options on reports</li>
    <li><b>Why is this feature important: </b> Allows admins to view user metrics within the training modules</li>
    <li><b>Where to find it:</b> Programs dashboard > Program Details > Course analytics > User metrics > Click Show Analytics Options </li>
    <li><b>Who is this feature for?:</b> Admins and sponsors</li>
  </ul>
  <p><b>Quick Summary</b></p>
  <ul>
    <li>Sponsors have requested the ability to closely examine users metrics within each training module.</li>
    <li>Site Admins can now choose to view two types of metric scores: The Likelihood of Deviation Occurring (LDO) score and the Impact of Non-Compliance (INC) score. This helps to see clear patterns between sites and a users' understanding of the protocol.</li>
  </ul>

  <p><b>New Feature 2: Release Notes functionality and UI</b></p>
  <ul>
    <li><b>What is the feature:</b> A short bullet list of the latest changes made to the Pro-ficiency system and website</li>
    <li><b>Why is this feature important: </b>As a user, you will be informed about changes made to certificates, reports, and surveys.</li>
    <li><b>Where to find it:</b> On the footer of the My Agenda page. Clicking the release note version number will showcase the latest update</li>
    <li><b>Who is this feature for?:</b> All site users</li>
  </ul>
  <p><b>Quick Summary</b></p>
  <ul>
    <li>When clicking the current version # in the footer, the user will be directed to a page displaying the current and previous Release Notes for the system.</li>
  </ul>

  <p><b>New Feature 3: Add full timestamp to certificates</b></p>
  <ul>
    <li><b>What is the feature:</b> Timestamp on certificates of completion</li>
    <li><b>Why is this feature important: </b> Ensures training completion time/timezone are available in addition to the day</li>
    <li><b>Where to find it:</b> On the Certificates page under My Agenda </li>
    <li><b>Who is this feature for?:</b> All site users</li>
  </ul>
  <p><b>Quick Summary</b></p>
  <ul>
    <li>All certificates of completion will now display the time the training module was completed and if applicable, the date the certificate will expire. For example:
      <ul>
        <li>Date of completion: January 17, 2022, 2:07 PM EST</li>
        <li>Certificate of expiration:  January 17, 2024, 2:07 PM EST</li>
      </ul>
    </li>
  </ul>
  `
}

export default releaseNotes;


// WEBPACK FOOTER //
// global/utils/releaseNotes.js